(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abundance-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('abundance-product-slider')) {
    customElements.define('abundance-product-slider', class extends HTMLElement {
      connectedCallback() {
        // Wait until children exist, including when re-rendered by the theme editor.
        this.initFrame = requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() {
        this.stopMomentum();
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.updateFrame);
        cancelAnimationFrame(this.dragFrame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }
      init() {
        this.stopMomentum();
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.events = new AbortController();
        this.updateFrame = null;
        this.dragFrame = null;
        const signal = this.events.signal;
        this.track = this.querySelector('.aps__track');
        this.prev = this.querySelector('.aps__arrow--prev');
        this.next = this.querySelector('.aps__arrow--next');
        if (!this.track) return;
        const listen = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal });
        this.drag = null;
        this.blockClick = false;
        listen(this.prev, 'click', () => this.move(-1));
        listen(this.next, 'click', () => this.move(1));
        listen(this.track, 'scroll', () => {
          if (this.updateFrame != null) return;
          this.updateFrame = requestAnimationFrame(() => {
            this.updateFrame = null;
            this.update();
          });
        }, { passive: true });
        listen(this.track, 'keydown', e => {
          if (e.target !== this.track) return;
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1);
          }
        });
        // Native touch scrolling is untouched. Only mouse dragging is handled here.
        listen(this.track, 'pointerdown', e => {
          this.stopMomentum();
          this.blockClick = false;
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          // Interrupt an in-flight arrow animation before starting 1:1 dragging.
          this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
          this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.drag = { id: e.pointerId, x: e.clientX, left: this.track.scrollLeft, active: false,
            samples: [{ x: e.clientX, t: performance.now() }] };
        });
        listen(window, 'pointermove', e => {
          if (!this.drag || e.pointerId !== this.drag.id) return;
          const delta = e.clientX - this.drag.x;
          if (!this.drag.active && Math.abs(delta) < 3) return;
          if (!this.drag.active) {
            this.drag.active = true;
            this.blockClick = true;
            this.track.classList.add('is-dragging');
          }
          e.preventDefault();
          const now = performance.now();
          this.drag.samples.push({ x: e.clientX, t: now });
          while (this.drag.samples.length > 2 && now - this.drag.samples[0].t > 90) this.drag.samples.shift();
          this.drag.target = Math.max(0, Math.min(this.maxScroll, this.drag.left - delta));
          // Coalesce high-frequency mouse events into one write per display frame.
          if (this.dragFrame == null) {
            this.dragFrame = requestAnimationFrame(() => {
              this.dragFrame = null;
              if (this.drag?.active) this.track.scrollLeft = this.drag.target;
            });
          }
        }, { passive: false });
        const endDrag = (e) => {
          if (e?.pointerId != null && this.drag && e.pointerId !== this.drag.id) return;
          cancelAnimationFrame(this.dragFrame);
          this.dragFrame = null;
          let velocity = 0;
          if (this.drag?.active && e?.type === 'pointerup') {
            const samples = this.drag.samples;
            const first = samples[0], last = samples[samples.length - 1];
            // A deliberate pause before release means stop, not a stale fling.
            if (performance.now() - last.t < 80 && last.t - first.t >= 8) {
              velocity = Math.max(-4, Math.min(4, (first.x - last.x) / (last.t - first.t)));
            }
          }
          if (this.drag?.active) this.track.scrollLeft = this.drag.target;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          if (Math.abs(velocity) > 0.08) this.startMomentum(velocity);
        };
        listen(window, 'pointerup', endDrag);
        listen(window, 'pointercancel', endDrag);
        listen(window, 'blur', e => { endDrag(e); this.stopMomentum(); });
        listen(this.track, 'wheel', () => this.stopMomentum(), { passive: true });
        listen(this.track, 'keydown', () => this.stopMomentum(), { capture: true });
        listen(this.track, 'click', e => {
          if (this.blockClick && e.detail !== 0) {
            e.preventDefault(); e.stopPropagation(); this.blockClick = false;
          }
        }, { capture: true });
        listen(this.track, 'dragstart', e => e.preventDefault());
        this.resizeObserver = new ResizeObserver(() => {
          this.stopMomentum();
          this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.update();
        });
        this.resizeObserver.observe(this.track);
        this.update();
      }
      move(direction) {
        this.stopMomentum();
        const card = this.track.querySelector('.aps__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduced ? 'auto' : 'smooth' });
      }
      stopMomentum() {
        cancelAnimationFrame(this.momentumFrame);
        this.momentumFrame = null;
      }
      startMomentum(velocity) {
        this.stopMomentum();
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const origin = this.track.scrollLeft;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const start = performance.now();
        const decay = 325;
        // Time-based exponential decay stays consistent at 60/120/144 Hz.
        const tick = now => {
          const elapsed = now - start;
          const remaining = Math.exp(-elapsed / decay);
          const target = Math.max(0, Math.min(max, origin + velocity * decay * (1 - remaining)));
          this.track.scrollLeft = target;
          if (target <= 0 || target >= max || Math.abs(velocity * remaining) < 0.015 || elapsed > 1800) {
            this.momentumFrame = null;
            this.update();
            return;
          }
          this.momentumFrame = requestAnimationFrame(tick);
        };
        this.momentumFrame = requestAnimationFrame(tick);
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.hidden = this.next.hidden = this.dataset.showArrows === 'false' || max < 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
